"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Warning_1 = __importDefault(require("@mui/icons-material/Warning"));
const material_1 = require("@mui/material");
const lodash_1 = __importDefault(require("lodash"));
const react_1 = require("react");
const shallow_1 = require("zustand/shallow");
const appConstants_1 = require("../../../../../constants/appConstants");
const strings_1 = require("../../../../../constants/strings");
const uiConstants_1 = require("../../../../../constants/uiConstants");
const status_and_notifications_1 = require("../../../../../hsbc_img/status_and_notifications");
const companyQuery_1 = require("../../../../../queries/companyQuery");
const zustandStore_1 = require("../../../../../zustandStore");
const typeInputButtonAdditionalSetting_1 = __importDefault(require("../../../../molecules/setting/typeInputButtonAdditionalSetting"));
const companyFeatureToggle_1 = __importDefault(require("../companyFeatureToggle"));
const handleWhiteListedDomainChange = ({ event, company, setCompanyProperty, saveCompanyProperty, setNotification, action, }) => {
    let updatedWhiteListedDomains = [];
    const previousValue = [...company.properties.whiteListedDomains];
    let key;
    if (action === appConstants_1.companyPropertiesExtendedConstants.addWhiteListedDomain) {
        updatedWhiteListedDomains = [...previousValue, event.target.value];
        key = appConstants_1.companyPropertiesExtendedConstants.addWhiteListedDomain;
    }
    else {
        updatedWhiteListedDomains = previousValue.filter(whiteListedDomain => whiteListedDomain !== event.target.value);
        key = appConstants_1.companyPropertiesExtendedConstants.removeWhiteListedDomain;
    }
    const value = event.target.value?.toLowerCase()?.trim();
    if (!value) {
        setNotification([
            {
                type: 'error',
                message: 'Sorry, we are having technical difficulties. Please try again later.',
            },
        ]);
        return;
    }
    const actionType = action === appConstants_1.companyPropertiesExtendedConstants.addWhiteListedDomain ? 'adding' : 'removing';
    saveCompanyProperty.mutate({
        companyId: company?.companyId,
        key,
        value,
    }, {
        onSuccess: () => {
            setCompanyProperty({
                key: 'whiteListedDomains',
                value: updatedWhiteListedDomains.join(','),
            });
        },
        onError: () => {
            setNotification([
                {
                    type: 'error',
                    message: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                        ? strings_1.errorStrings.DEFAULT
                        : `There was an error ${actionType} the domain ${value}, please try again.`,
                },
            ]);
        },
    });
};
const DomainWhitelistingFeatureToggle = () => {
    const { company, companyErrors, setNotification, setCompanyProperty, setCompanyErrors, setIsCompanySettingsSaveBtnDisabled, } = (0, zustandStore_1.useZustand)((0, shallow_1.useShallow)(state => ({
        company: state.company,
        companyErrors: state.company.companyErrors,
        setCompanyErrors: state.setCompanyErrors,
        setNotification: state.setNotification,
        setCompanyProperty: state.setCompanyProperty,
        setIsCompanySettingsSaveBtnDisabled: state.setIsCompanySettingsSaveBtnDisabled,
    })));
    const saveCompanyProperty = (0, companyQuery_1.useSaveCompanyPropertyQuery)();
    (0, react_1.useEffect)(() => {
        if (company?.features?.ENABLE_DOMAIN_WHITELISTING &&
            company.properties.whiteListedDomains.filter(Boolean).length === 0) {
            setCompanyErrors({
                ...companyErrors,
                [appConstants_1.companyFeaturesConstants.enableDomainWhitelisting]: strings_1.companySettingsOverviewStrings.FEATURE_ENABLE_DOMAIN_WHITELISTING_WARNING,
            });
            setIsCompanySettingsSaveBtnDisabled(true);
        }
        else {
            setCompanyErrors(lodash_1.default.omit(companyErrors, [appConstants_1.companyFeaturesConstants.enableDomainWhitelisting]));
        }
    }, [company?.features?.ENABLE_DOMAIN_WHITELISTING, company.properties.whiteListedDomains]);
    return ((0, jsx_runtime_1.jsx)(companyFeatureToggle_1.default, { featureKey: appConstants_1.companyFeaturesConstants.enableDomainWhitelisting, label: strings_1.companySettingsOverviewStrings.FEATURE_ENABLE_DOMAIN_WHITELISTING, ui: company?.features?.ENABLE_DOMAIN_WHITELISTING && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(typeInputButtonAdditionalSetting_1.default, { dataTestId: 'enable_domain_whitelisting_feature_toggle', mainClass: uiConstants_1.UI_CLASS_COMPANY_SETTINGS_DOMAIN, name: appConstants_1.companyPropertiesConstants[appConstants_1.companyPropertiesConstants.whiteListedDomains], buttonName: strings_1.companySettingsOverviewStrings.FEATURE_ENABLE_DOMAIN_WHITELISTING_BUTTON_NAME, buttonColor: uiConstants_1.UI_BUTTON_SECONDARY, size: 'small', placeholder: strings_1.companySettingsOverviewStrings.FEATURE_ENABLE_DOMAIN_WHITELISTING_INPUT_PLACEHOLDER, tags: company.properties.whiteListedDomains || [], onButtonClick: (_key, value) => {
                        handleWhiteListedDomainChange({
                            event: { target: { value } },
                            company,
                            setCompanyProperty,
                            saveCompanyProperty,
                            setNotification,
                            action: appConstants_1.companyPropertiesExtendedConstants.addWhiteListedDomain,
                        });
                        if (Object.keys(companyErrors).length > 0 &&
                            appConstants_1.companyFeaturesConstants.enableDefaultExpirationDate in companyErrors) {
                            setIsCompanySettingsSaveBtnDisabled(true);
                        }
                        else {
                            setIsCompanySettingsSaveBtnDisabled(false);
                        }
                    }, onTagClick: (_key, value) => {
                        handleWhiteListedDomainChange({
                            event: { target: { value } },
                            company,
                            setCompanyProperty,
                            saveCompanyProperty,
                            setNotification,
                            action: appConstants_1.companyPropertiesExtendedConstants.removeWhiteListedDomain,
                        });
                        setIsCompanySettingsSaveBtnDisabled(false);
                    }, visible: true, style: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '5px',
                        paddingRight: 0,
                        paddingLeft: 0,
                    } }), companyErrors[appConstants_1.companyFeaturesConstants.enableDomainWhitelisting] && ((0, jsx_runtime_1.jsx)(material_1.Alert, { severity: "error", variant: 'outlined', sx: { pt: 0 }, icon: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? ((0, jsx_runtime_1.jsx)(status_and_notifications_1.StatusErrorOnLight, { style: { width: '24px', height: '24px' } })) : ((0, jsx_runtime_1.jsx)(Warning_1.default, {})), children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "caption", sx: {
                            color: 'error',
                        }, children: companyErrors[appConstants_1.companyFeaturesConstants.enableDomainWhitelisting] }) }))] })) }));
};
exports.default = (0, react_1.memo)(DomainWhitelistingFeatureToggle);
